import React from 'react'
import { IErrorResponse } from '../types/ErrorResponse'
import OrderBumpController from '../controllers/OrderBumpController'
import { IOrderBump } from '../types/OrderBump'

export interface IOrderBumpProp {
  id: string
}

export const useOrderBump = ({ id }: IOrderBumpProp) => {
  const [loading, setLoading] = React.useState<boolean>(false)
  const [data, setData] = React.useState<IOrderBump | null>(null)
  const [error, setError] = React.useState<string>('')

  const execute = async () => {
    if (id === '' || id === 'new') {
      return
    }

    if (!loading) {
      try {
        setLoading(true)

        if (error !== '') {
          setError('')
        }
        if (data !== null) {
          setData(null)
        }

        const response = await OrderBumpController.get({ id })
        const responseError = response as IErrorResponse
        const responseData = response as IOrderBump

        if (responseError.code) {
          setError(responseError.error)
        } else {
          setData(responseData)
        }
      } catch (e) {
        var message = 'Erro não identificado'
        if (typeof e === 'string') {
          message = e.toUpperCase()
        } else if (e instanceof Error) {
          const err = e as Error
          message = err.message
        }
        setError(message)
      } finally {
        setLoading(false)
      }
    }
  }

  React.useEffect(() => {
    execute()
  }, [id])

  const clear = () => {
    setError('')
  }

  return {
    loading,
    data,
    error,
    execute,
    clear,
  }
}
